import { styled } from '@mui/material/styles';
import StyledAgentImage from '../../styles/StyledAgentImage';

const StyledWelcomeAgentImage2 = styled(StyledAgentImage)`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 48%;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 250px;
    position: absolute;
    top: 4%;
    right: 4%;
    left: auto;
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    width: 290px;
  }
`;

export default StyledWelcomeAgentImage2;
